import { doc, getDoc, updateDoc, increment, collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db, auth } from "../authentication/firebase";

/**
 * Process project contribution payment on the client side
 * This is a temporary solution until proper webhook handling is implemented
 */
export const processProjectPaymentSuccess = async (projectId, contributionAmount = 10) => {
  try {
    const user = auth.currentUser;
    if (!user) {
      console.error("No authenticated user found");
      return { success: false, error: "No authenticated user" };
    }

    // Verify the project exists
    const projectRef = doc(db, "projects", projectId);
    const projectSnap = await getDoc(projectRef);
    
    if (!projectSnap.exists()) {
      console.error("Project not found:", projectId);
      return { success: false, error: "Project not found" };
    }

    // Update the project's contributed amount
    await updateDoc(projectRef, {
      contributedAmount: increment(contributionAmount),
      lastUpdated: serverTimestamp()
    });

    // Log the contribution for tracking
    const contributionsRef = collection(db, "projectContributions");
    await addDoc(contributionsRef, {
      projectId,
      userId: user.uid,
      userEmail: user.email,
      amount: contributionAmount,
      timestamp: serverTimestamp(),
      status: "completed",
      paymentMethod: "stripe"
    });

    console.log(`Successfully processed $${contributionAmount} contribution to project ${projectId}`);
    return { 
      success: true, 
      projectName: projectSnap.data().title,
      contributionAmount 
    };
  } catch (error) {
    console.error("Error processing project payment:", error);
    return { success: false, error: error.message };
  }
};

/**
 * Check if payment was for a project contribution based on URL params
 */
export const checkProjectContribution = (urlSearch) => {
  const urlParams = new URLSearchParams(urlSearch);
  const projectId = urlParams.get('project');
  return projectId;
};